import React, { useState } from "react";
import { toClass } from "./index";
import "./tabbedpanel.css";
export function TabbedPanel(props) {
    var _a = useState(function () { return props.titles[0]; }), selected = _a[0], set_selected = _a[1];
    var child = null;
    if (Array.isArray(props.children)) {
        child = props.children[props.titles.indexOf(selected)];
    }
    return React.createElement("div", { className: "tabbed-pane" },
        React.createElement("div", { className: "tab-titles" }, props.titles.map(function (title) { return React.createElement("button", { className: toClass({ "tab-title": true, selected: selected === title }), key: title, onClick: function () { return set_selected(title); } }, title); })),
        React.createElement("div", { className: "tab-content" }, child ? child : "empty"));
}
